import { render } from "./M2ChartJs.vue?vue&type=template&id=4019ec62&scoped=true"
import script from "./M2ChartJs.vue?vue&type=script&lang=js"
export * from "./M2ChartJs.vue?vue&type=script&lang=js"

import "./M2ChartJs.vue?vue&type=style&index=0&id=4019ec62&scoped=true&lang=css"
import "./M2ChartJs.vue?vue&type=style&index=1&id=4019ec62&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4019ec62"],['__file',"src/components/element/M2ChartJs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4019ec62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4019ec62', __exports__)) {
    api.reload('4019ec62', __exports__)
  }
  
  module.hot.accept("./M2ChartJs.vue?vue&type=template&id=4019ec62&scoped=true", () => {
    api.rerender('4019ec62', render)
  })

}


export default __exports__